import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=7cae5d98&scoped=true"
var script = {}
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=7cae5d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cae5d98",
  null
  
)

export default component.exports